(function($){ 
    $.Component = function(component_func) {
        this._component_func = component_func; //save original function
        // this._subcomponents = component_func._subcomponents;
        // this._subcomponents_instances = component_func._subcomponents_instances;
        // this._component_func._subcomponents_state = component_func._subcomponents_state;
        this._component_ready = false; 

        this._init_subcomponents();
    };
    
    $.Component.create = function(component_func, members, parent_func, delayed) {
        $._inherit(component_func, $.Component); 
        Object.assign(component_func.prototype, members);

        component_func._subcomponents = [];
        component_func._subcomponents_instances = [];
        component_func._subcomponents_state = []; 
        if (typeof(delayed) === 'undefined') {
            delayed = false;
        }

        if (arguments.length == 3 && typeof(parent_func) === "undefined") {
            console.error("Parent component not found");
            console.error("current component: " + component_func);
        }

        // if subcomponent
        if (parent_func) {
            component_func._instance = new component_func();
            var index = parent_func._subcomponents.push(component_func) - 1;

            if (typeof(parent_func._instance) !== 'undefined') {
                var pinstance = parent_func._instance;
                if (delayed) {
                    pinstance._init_subcomponent.call(pinstance, component_func, index);
                }
                else {
                    // pinstance._on("ready", pinstance._init_subcomponent.bind(pinstance, component_func, index));                
                }
                // pinstance._init_subcomponent(component_func, parent_func._subcomponents.length - 1);
            }
        }
    };

    $.Component.prototype = { 

        _events: { ready: "ready", subcomponents_ready: "subcomponents_ready" },
        /**
         * initialize subcomponents with name _subcomponent_<component_name>_init
         */
        _init_subcomponents: function() {
            if (!("ready" in this._events)) {
                this._events.ready = "ready";
            }

            if (!("subcomponents_ready" in this._events)) {
                this._events.subcomponents_ready = "subcomponents_ready";
            }

            var subcomponents_length = this._component_func._subcomponents.length, i;

            for (i = 0; i < subcomponents_length; i++) {
                this._component_func._subcomponents_state.push(0);
            }
            
            for (i = 0; i < subcomponents_length; i++) {
                this._init_subcomponent(this._component_func._subcomponents[i], i);
            }
        },

        _init_subcomponent: function(subcomponent, index) { 
            var instance = subcomponent._instance;
                
            // initialize hierarchy
            instance.parent = this;
            if (instance._component_name) {
                this[instance._component_name] = instance;
            }

            var options = {};
            var has_options = typeof(this._options) !== "undefined" && typeof(this._options[instance._component_name]) !== "undefined";
            if (has_options) {
                options = this._options[instance._component_name];
            }
            
            
            instance._on("ready", this._on_subcomponent_ready.bind(this, index));
            this._component_func._subcomponents_instances.push(instance); 

            // if it has a function _init()
            if (typeof(instance._init) === "function") {
                // call it with parameters from this._options.<component_name>
                if (options) {
                    instance._init.call(instance, options); 
                }
                else {
                    instance._init.call(instance); 
                }
            }

            return instance;
        },

        _on_subcomponent_ready: function(index) {
            // console.log(`subcomponent: ${this._component_func._subcomponents_instances[index]._component_name} ready`);
            this._component_func._subcomponents_state[index] = 1;

            if (this._all_subcomponents_ready()) {
                // console.log("All subcomponents ready: " + this._component_name);
                // this._emit(this._events.subcomponents_ready);
            }
        },

        _all_subcomponents_ready: function() {
            var sum = 0, subcomponents_n = this._component_func._subcomponents_state.length, i;
            for (i = 0; i < subcomponents_n; i++) {
                sum += this._component_func._subcomponents_state[i];
            }

            return sum == subcomponents_n;
        },

        _add_event:function(name) {
            this._events[name] = name;
        },

        _get_event_name: function(event_name) {
            return this._component_name + '_' + event_name;
        },

        /**
         * Wrapper to global events ABDOMap.on()
         * @param {String} event_name 
         * @param {Function} func 
         */
        _on: function(event_name, func) {
            var event_full_name = this._get_event_name(event_name);
            $.on.call($, event_full_name, func);
        },

        /**
         * Wrapper to global events ABDOMap.once()
         * @param {String} event_name 
         * @param {Function} func 
         */
         _once: function(event_name, func) {
            var event_full_name = this._get_event_name(event_name);
            $.once.call($, event_full_name, func); 
        },

        /**
         * Wrapper to global events ABDOMap.emit()
         * @param {String} event_name 
         * @returns 
         */
        _emit: function(event_name) {
            if(arguments.length == 0) {
                return;
            }
    
            var args = [this._get_event_name(event_name)];
    
            for (var i = 1; i < arguments.length; i++) {
                args.push(arguments[i]);
            }
            
            $.emit.apply($, args);
        },

        _get_component_name: function() {
            return this._component_name || 'anonymous_component';
        },

        
        _log: function(msg) { 
            console.log('[' + this._get_component_name() + '] ' + msg);
        },
        _error: function() { 
            console.error('[' + this._get_component_name() + '] ' + msg);
        }
        
    };
 
})(ABDOMap);
